// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.legal-intro {
  font-size: 0.875rem;
  color: #999;
  margin-bottom: 2rem;
  font-style: italic;
}

.legal-section {
  margin-bottom: 2rem;
}

.legal-section h2 {
  color: #1a1a2e;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #4ecca3;
}

.legal-section p {
  color: #555;
  line-height: 1.8;
  margin-bottom: 1rem;
}

.legal-section ul {
  margin-left: 2rem;
  margin-bottom: 1rem;
}

.legal-section li {
  color: #555;
  line-height: 1.8;
  margin-bottom: 0.5rem;
}

@media (max-width: 768px) {
  .legal-content {
    padding: 1.5rem;
  }

  .legal-section h2 {
    font-size: 1.25rem;
  }

  .legal-section ul {
    margin-left: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LegalPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".legal-content {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.legal-intro {\n  font-size: 0.875rem;\n  color: #999;\n  margin-bottom: 2rem;\n  font-style: italic;\n}\n\n.legal-section {\n  margin-bottom: 2rem;\n}\n\n.legal-section h2 {\n  color: #1a1a2e;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #4ecca3;\n}\n\n.legal-section p {\n  color: #555;\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\n.legal-section ul {\n  margin-left: 2rem;\n  margin-bottom: 1rem;\n}\n\n.legal-section li {\n  color: #555;\n  line-height: 1.8;\n  margin-bottom: 0.5rem;\n}\n\n@media (max-width: 768px) {\n  .legal-content {\n    padding: 1.5rem;\n  }\n\n  .legal-section h2 {\n    font-size: 1.25rem;\n  }\n\n  .legal-section ul {\n    margin-left: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
